import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { de } from "./de";
import { en } from "./en";

const STORAGE_KEY = "grantonomy.lang";
const SUPPORTED_LANGS = ["de", "en"] as const;

export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

function isSupportedLang(value: string | null): value is SupportedLang {
  return value === "de" || value === "en";
}

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: "de",
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export function syncClientLanguage() {
  const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
  const language = isSupportedLang(savedLanguage) ? savedLanguage : "de";

  if (i18n.language !== language) {
    void i18n.changeLanguage(language);
  }
  document.documentElement.lang = language;
}

export function persistClientLanguage(language: SupportedLang) {
  window.localStorage.setItem(STORAGE_KEY, language);
  document.documentElement.lang = language;
}

export default i18n;
